import { useContext, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { LotDetailContext } from '../../../Contexts/LotDetailContext';
import DataTable from '../../../DataTable/datatable.component';
import DateColumn from '../../../DataTable/datatable.datecolumn';

const RelatedLotsSection = memo(function RelatedLotsSection() {

    const { t } = useTranslation();
    const {
        lotDetail:
        {
            summary: {
                lotNumber
            },
            relatedLots
        }
    } = useContext(LotDetailContext);

    const tableColumns = [
        {
            Header: t('LotDetails.RelatedLots.LotNumber'),
            accessor: 'lotNumber',
            Cell: (props: any) => {
                return props.value === lotNumber
                    ? <span>{props.value}</span>
                    : <Link to={{ pathname: `/lotdetails/${props.value}` }} target="_blank">{props.value}</Link>;
            }
        },
        {
            Header: t('LotDetails.RelatedLots.Grade'),
            accessor: 'grade'
        },
        {
            Header: t('LotDetails.RelatedLots.Status'),
            accessor: 'status',
            Cell: (props: any) => {
                return t('LotStatus.' + props.value);
            }
        },
        DateColumn({ header: t('LotDetails.RelatedLots.LotStart'), accessor: 'lotStartUtc' }),
        DateColumn({ header: t('LotDetails.RelatedLots.LotEnd'), accessor: 'lotEndUtc' }),
        {
            Header: t('LotDetails.RelatedLots.Quality'),
            accessor: 'quality'
        },
        {
            Header: t('LotDetails.RelatedLots.Notes'),
            accessor: 'notes'
        },
    ];

    const initialState = {
        sortBy: [
            {
                id: 'lotStartUtc',
                desc: false
            }
        ]
    };

    return relatedLots?.length > 0
        ? <DataTable tableColumns={tableColumns} tableData={relatedLots} initialState={initialState} showPaging={false} />
        : <span>{t('CommonResponses.NoData')}</span>;
});

export default RelatedLotsSection;